import { useState, FormEvent, useEffect } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const [formUrl, setFormUrl] = useState('');

  useEffect(() => {
    const fetchFormUrl = async () => {
      const result = await (window as any).__readdy_get_form_url?.('吃瓜爆料订阅');
      if (result?.submitAddr) {
        setFormUrl(result.submitAddr);
      }
    };
    fetchFormUrl();
  }, []);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotVal = (formData.get('website_alt') as string || '').trim();
    if (honeypotVal) {
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }

    if (!email.trim()) return;

    if (!formUrl) {
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: email.trim() }).toString(),
      });
      const responseText = await response.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
        setTimeout(() => setStatus('idle'), 3000);
      } else {
        const msg = parsed?.meta?.message || parsed?.message || responseText || '提交失败，请稍后重试';
        if (msg.toLowerCase().includes('spam')) {
          setStatus('success');
          setEmail('');
          setTimeout(() => setStatus('idle'), 3000);
        } else {
          setStatus('error');
          setErrorMsg(msg);
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20dramatic%20paparazzi%20style%20scene%20with%20camera%20flashes%2C%20dark%20atmospheric%20night%20street%2C%20red%20carpet%20vibe%2C%20entertainment%20news%20breaking%20story%20aesthetic%2C%20cinematic%20mood%20with%20warm%20orange%20and%20deep%20red%20accents%2C%20editorial%20photography&width=1600&height=900&seq=cta-bg-subscribe&orientation=landscape"
          alt="订阅吃瓜爆料"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-background-50 font-heading mb-3 tracking-wide">
          第一手黑料 不错过
        </h2>
        <p className="text-sm md:text-base text-background-50/70 max-w-lg mb-8">
          订阅吃瓜爆料网每日推送，明星塌房、网红翻车第一时间送达
        </p>

        <form
          onSubmit={handleSubmit}
         
          id="subscribe-form"
          className="flex flex-col sm:flex-row items-center gap-0 w-full max-w-md"
        >
          <input
            name="website_alt"
            type="text"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <div className="flex w-full">
            <div className="flex-1 relative">
              <span className="absolute left-4 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center bg-accent-500 rounded-full">
                <i className="ri-notification-3-line text-sm text-background-50"></i>
              </span>
              <input
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入邮箱地址"
                required
                className="w-full h-12 pl-14 pr-4 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 placeholder:text-background-50/40 rounded-l-full text-sm focus:outline-none focus:border-primary-400"
              />
            </div>
            <button
              type="submit"
              disabled={status === 'loading'}
              className="h-12 px-6 bg-background-50 hover:bg-background-100 text-foreground-950 font-bold rounded-r-full text-sm transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 disabled:opacity-60"
            >
              {status === 'loading' ? '提交中...' : '订阅推送'}
              <i className="ri-arrow-right-up-line text-sm"></i>
            </button>
          </div>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-accent-300">订阅成功！猛料将第一时间送达你的邮箱 🍉</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-primary-300">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}